import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { monedaRoutesMap } from './MonedaRoutesMap'

const AppMonedaGestion = Loadable(lazy(() => import('./view/listado/Moneda')))
const AppMonedaTienda = Loadable(lazy(() => import('./view/monedaTienda/MonedaTienda')))

const monedaRoutes = [
  {
    path: monedaRoutesMap.gestion.path,
    element: <AppMonedaGestion />,
    auth: authRoles.admin,
  },
  {
    path: monedaRoutesMap.tienda.path,
    element: <AppMonedaTienda />,
    auth: authRoles.admin,
  },
]

export default monedaRoutes
